import { render, staticRenderFns } from "./perDetail.vue?vue&type=template&id=006efc6c&scoped=true&"
import script from "./perDetail.vue?vue&type=script&lang=js&"
export * from "./perDetail.vue?vue&type=script&lang=js&"
import style0 from "./perDetail.vue?vue&type=style&index=0&id=006efc6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006efc6c",
  null
  
)

export default component.exports